module.exports = __webpack_public_path__ + "static/img/sec2-slide-img01.b143ef9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/hanssem/sec2-slide-img01.png
// module id = Ob7l
// module chunks = 0